import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Menu from '../menu/Menu';
import Tile from '../common/Tile';
import '../common/rtCommon.css';
import './PGManagement.css';

const tiles = [
	{
		title: 'Add Paying Guest Details',
		icon: '🧑',
		description: 'Add a new paying guest.',
		permissions: ['add_pg'],
		url: 'add',
	},
	{
		title: 'View Paying Guest',
		icon: '👀',
		description: 'View and manage all your paying guest details.',
		permissions: ['view_pg'],
		url: 'list',
	}
];

const PGManagement = () => {
	const navigate = useNavigate();
	const location = useLocation();

	return (
		<div className="rt-layout">
			<Menu className="rt-menu" activePath={location.pathname} />
			<div className="rt-main-content">
				<div className="rt-title-row">
					<h2 className="rt-title">Paying Guest Management</h2>
				</div>
				<div className="rt-main-section">
					<div className="rt-tiles-grid">
						{tiles.map((tile, idx) => (
							<Tile
								key={idx}
								title={tile.title}
								icon={tile.icon}
								description={tile.description}
								access_roles={['RT_Admin']}
								onClick={() => tile.url && navigate(tile.url)}
								tabIndex={0}
								role="button"
								onKeyPress={e => { if (e.key === 'Enter' && tile.url) navigate(tile.url); }}
							/>
						))}
					</div>
				</div>
			</div>
		</div>
	);
};

export default PGManagement;